import LocationForm from './location/LocationForm.vue'
import { mapGetters, mapState } from 'vuex'
import DeliveryService from '../../services/delivery/DeliveryService'

export default {
    components: {
        LocationForm
    },
    data() {
        return {
            activeStep: 0,
            sendingDelivery: false,
            orderCode: ''
        }
    },

    created() {
        this.validateMedicinesState()
    },

    computed: {
        ...mapState('delivery', {
            patient: 'patient',
            provider: 'provider',
            orderDetails: 'orderDetails',
            selectedMedicines: 'selectedMedicines',
            shippingFee: 'shippingFee',
            state: 'state',
            city: 'city',
            branch: 'branch',
            schedule: 'schedule',
            scheduleName: 'scheduleName',
            address: 'address',
            observations: 'observations',
            phone: 'phone',
            cellPhone: 'cellPhone',
            nameNomenclature: 'nameNomenclature',
            numberOne: 'numberOne',
            numberTwo: 'numberTwo',
            numberThree: 'numberThree',
            propertyType: 'propertyType',
            complementOne: 'complementOne',
            blockOrInside: 'blockOrInside',
            complementTwo: 'complementTwo',
            minDate: 'minDate',
            maxDate: 'maxDate'
        }),
        ...mapGetters('delivery', {
            slidingScaleFee: 'slidingScaleFee',
            shippingDate: 'shippingDate'
        })
    },

    methods: {
        nextStep() {
            this.activeStep += 1;
        },

        previousStep() {
            this.activeStep -= 1;
        },

        validateMedicinesState() {
            if (!this.selectedMedicines || this.selectedMedicines.length == 0)
                this.$router.push('/home')
        },

        async sendDelivery() {
            const datamedicienes = this.orderDetails.map(element => {
               return  element.medicines
            })

            this.sendingDelivery = true
            try {
                const order = {
                    patients: [{
                        documentType: this.patient.identificationType,
                        document: this.patient.identification,
                        fullname: this.patient.name,
                        address: this.patient.address,
                        phoneNumber: this.phone,
                        mobilePhone: this.cellPhone
                    }],
                    orderData: {
                        status: 'SCHEDULED',
                        deliveryAddress: this.address,
                        nameNomenclature: this.nameNomenclature,
                        numberOne: this.numberOne,
                        numberTwo: this.numberTwo,
                        numbreThree: this.numberThree,

                        typeProperty: this.propertyType,
                        observationOne: this.complementOne,
                        blockOrInterior: this.blockOrInside,
                        observationTwo: this.complementTwo,

                        minDate: this.minDate,
                        maxDate: this.maxDate,
                        orderType: this.provider == 1 ? 'INTEGRATED' : 'EXCLUSIVE',
                        deliveryDate: this.shippingDate,
                        notApplyShippingFee: this.shippingFee == 0 ? true : false,
                        shippingFee: this.shippingFee,
                        orderDetail: this.getOrderDetails(this.orderDetails),
                        medicinesList: datamedicienes[0],
                       
                        location: {
                            state: this.state,
                            city: this.city,
                            branch: this.branch,
                            scheduleRange: this.schedule
                        }
                    },
                    provider: this.provider,
                    observation: this.observations
                }
                const response = await DeliveryService.sendDelivery(order)
                if (response.data) {
                    if (response.data.id) {
                        this.orderCode = response.data.id

                        this.sendingDelivery = false
                        this.nextStep()
                    } else {
                        throw new Error('error')
                    }
                } else {
                    throw new Error('error')
                }
            } catch (error) {
                if (error === 'Wrong authorization' || error === 'No authorization') {
                    const message = 'Alguna de las autorizaciones ya ha sido agendada, regresa a la página de inicio para obtener la lista actualizada de autorizaciones';
                    this.$buefy.toast.open({ message, type: 'is-danger', duration: 15000 })
                    this.sendingDelivery = false
                } else if (error === 'Wrong date') {
                    const message = 'La fecha de envío no es válida, selecciona otra fecha';
                    this.$buefy.toast.open({ message, type: 'is-danger', duration: 15000 })
                    this.sendingDelivery = false
                } else {
                    const message = this.$t('app.components.delivery.an-error-ocurred-registering-delivery');
                    this.$buefy.toast.open({ message, type: 'is-danger' })
                    this.sendingDelivery = false
                }
            }
        },

        getOrderDetails(orderDetails) {
            return orderDetails.map(orderDetail => {
                orderDetail.medicines = orderDetail.medicines.map(medicine => {
                    medicine.orderCode = medicine.orderDetailCode
                    medicine.count = medicine.quantity
                    return medicine
                })
                return orderDetail
            })
        },

        goHome() {
            this.$router.push('/home')
        }
    }
}